export const all_races = [ //An array of each Race's ID and name.
  /* The first 9 skin-colours appear in Fallout Shelter. */
  {
    id: 'skin1', //For skincolor, append ?? to find class of div.
    name: 'Human' //Show name in textbox.
  },
  {
    id: 'skin2',
    name: 'Human'
  },
  {
    id: 'skin3',
    name: 'Human'
  },
  {
    id: 'skin4',
    name: 'Human'
  },
  {
    id: 'skin5',
    name: 'Human'
  },
  {
    id: 'skin6',
    name: 'Human'
  },
  {
    id: 'skin7',
    name: 'Human'
  },
  {
    id: 'skin8',
    name: 'Human'
  },
  {
    id: 'skin9',
    name: 'Human'
  },

  /* The following skin-colours are not in-game, but I wanted to include them. */
  {
    id: 'skin10',
    name: 'Super Mutant'
  },
  /* Feral Ghoul */
  /* Glowing One */
  /* Zetan? */
  {
    id: 'skin11',
    name: 'Mannequin'
  },
  {
    id: 'skin12',
    name: 'An Alien!'
  },
  {
    id: 'skin13',
    name: 'Dr. Manhattan'
  }
]